import React from 'react';
import { styled } from '@mui/material/styles';
import { Box, Typography, Link } from '@mui/material';

const FooterContainer = styled(Box)(({ theme }) => ({
  marginTop: '10%',
  backgroundColor: theme.palette.grey[900],
  color: theme.palette.grey[300],
  padding: theme.spacing(3),
  textAlign: 'center',
}));

const Highlight = styled('span')(({ theme }) => ({
  fontWeight: 'bold',
  color: theme.palette.primary.main,
}));

const Footer = () => {
  return (
    <FooterContainer>
      <Typography variant="body2" component="p" gutterBottom>
        This project is a practice exercise and part of an application for the{' '}
        <Highlight>Check24 GenDev Scholarship</Highlight>.
      </Typography>
      <Typography variant="body2" component="p" gutterBottom>
        It utilizes external images and other resources purely for educational
        purposes.
      </Typography>
      <Typography variant="body2" component="p" gutterBottom>
        Developed by <Highlight>David Luff</Highlight>, 2024.
      </Typography>
      <Typography variant="body2" component="p">
        For any inquiries, please contact:{' '}
        <Link href="mailto:david.luff03@gmail.com" color="inherit">
          david.luff03@gmail.com
        </Link>
      </Typography>
    </FooterContainer>
  );
};

export default Footer;
